import ImportIcon from '@material-ui/icons/Publish';
import React, { FC, ReactElement } from 'react';
import PropTypes from 'prop-types';
import { Fab, makeStyles, useMediaQuery, Theme } from '@material-ui/core';
import classnames from 'classnames'
import { Link } from 'react-router-dom';
import { Button } from 'react-admin'
import { useTranslate } from 'ra-core';

interface ButtonProps {
    alignIcon?: 'left' | 'right';
    children?: ReactElement;
    classes?: object;
    className?: string;
    color?: any;
    disabled?: boolean;
    label?: string;
    size?: 'small' | 'medium' | 'large';
}

const ImportButton: FC<CreateButtonProps> = props => {
    const {
        basePath = '',
        className,
        classes: classesOverride,
        label = 'Import',
        icon = defaultIcon,
        ...rest
    } = props;
    const classes = useStyles(props);
    const translate = useTranslate();
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return isSmall ? (
        <Fab
            component={Link}
            color="primary"
            className={classnames(classes.floating, className)}
            to={`${basePath}/import`}
            aria-label={label && translate(label)}
            {...rest as any}
        >
            {icon}
        </Fab>
    ) : (
        <Button
            component={Link}
            to={`${basePath}/import`}
            className={className}
            label={label}
            {...rest as any}
        >
            {icon}
        </Button>
    );
};

const defaultIcon = <ImportIcon />;

const useStyles = makeStyles(
    theme => ({
        floating: {
            color: theme.palette.getContrastText(theme.palette.primary.main),
            margin: 0,
            top: 'auto',
            right: 20,
            bottom: 60,
            left: 'auto',
            position: 'fixed',
            zIndex: 1000,
        },
        floatingLink: {
            color: 'inherit',
        },
    }),
    { name: 'RaCreateButton' }
);

interface Props {
    basePath?: string;
    icon?: ReactElement;
    variant?: string;
}

export type CreateButtonProps = Props & ButtonProps;

ImportButton.propTypes = {
    basePath: PropTypes.string,
    classes: PropTypes.object,
    className: PropTypes.string,
    icon: PropTypes.element,
    label: PropTypes.string,
};

export default ImportButton;